import { LINK_CG_TERMINAL_FORM } from '../form-tcg-types';
import { showToast } from '../../../toasts';

import PostTerminalCardGroup from '../../../../routes/post-terminal-card-group';

/**
 * Formats a list of card groups by id to send to AWS
 * 
 * @param {string} terminalId the terminal's id that the card groups are being associated with.
 */
export const addTerminalCardGroup = async (terminalId: string) => {
  const cardGroupList = document.querySelectorAll<HTMLElement>('[data-linked]');
  let accessList: string = '';

  if ( cardGroupList ) {
    [...cardGroupList].forEach(e => {
      let cardGroupId = e.getAttribute('data-linked');
      accessList += cardGroupId + ',';
    });
  }

  const awsData = {
    terminalID: terminalId,
    cardGroups: accessList.slice(0, -1)
  }

  PostTerminalCardGroup(awsData)
    .then(response => {
      showToast('aafp_toast', `${LINK_CG_TERMINAL_FORM.terminalName.value} has been updated`);
    });
}